import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth/auth-guard';
import { companyIntegrityGuard } from '@core/guards/components/company-guard';

export const routes: Routes = [
  {
    path: 'auth/login',
    loadComponent: () => import('./features/auth/login/login').then((m) => m.Login),
  },
  {
    path: '',
    loadComponent: () => import('./core/layout/layout').then((m) => m.Layout),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () => import('./features/home/home').then((m) => m.Home),
      },
      {
        path: 'companies',
        children: [
          {
            path: 'create',
            loadComponent: () =>
              import('./features/companies/create-company/create-company').then(
                (m) => m.CreateCompany,
              ),
          },
          {
            path: 'edit/:id',
            loadComponent: () =>
              import('./features/companies/edit-company/edit-company').then((m) => m.EditCompany),
          },
          {
            path: 'list',
            loadComponent: () =>
              import('./features/companies/list-company/list-company').then((m) => m.ListCompany),
          },
          {
            path: 'sifs/:companyId',
            canActivate: [companyIntegrityGuard],
            children: [
              {
                path: 'list',
                loadComponent: () =>
                  import('./features/sif/list-sif/list-sif').then((m) => m.ListSif),
              },
              {
                path: 'create',
                loadComponent: () =>
                  import('./features/sif/create-sif/create-sif').then((m) => m.CreateSif),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./features/error/error404/error404').then((m) => m.Error404),
  },
];
